export const SET_TURMA = 'SET_TURMA';
export const SET_TURMAS = 'SET_TURMAS';
export const OPEN_SEARCH_TURMAS = 'OPEN_SEARCH_TURMAS';
export const CLOSE_SEARCH_TURMAS = 'CLOSE_SEARCH_TURMAS';
export const ADD_TURMAS = 'ADD_TURMAS';
export const UPDATE_TURMAS = 'UPDATE_TURMAS';
export const REMOVE_TURMAS = 'REMOVE_TURMAS';